import { graphql } from "../generated/gql";

export const GenerateAIAnswers = graphql(`
  mutation GenerateAIAnswers($input: GenerateAIAnswersInput!) {
    generateAIAnswers(input: $input)
  }
`);
